import { render, staticRenderFns } from "./OptionGroups.vue?vue&type=template&id=c4c6b280&scoped=true"
import script from "./OptionGroups.vue?vue&type=script&lang=js"
export * from "./OptionGroups.vue?vue&type=script&lang=js"
import style0 from "./OptionGroups.vue?vue&type=style&index=0&id=c4c6b280&prod&lang=css"
import style1 from "./OptionGroups.vue?vue&type=style&index=1&id=c4c6b280&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c6b280",
  null
  
)

export default component.exports